import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

export function PageTransition({ children }) {
  const location = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [transitionState, setTransitionState] = useState("entered");
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    // Skip transition on initial mount
    if (previousPathRef.current === location.pathname) {
      return;
    }

    // Check for reduced motion preference
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setDisplayChildren(children);
      previousPathRef.current = location.pathname;
      return;
    }

    // Start exit transition
    setTransitionState("exiting");

    const exitTimer = setTimeout(() => {
      // Update content and start enter transition
      setDisplayChildren(children);
      setTransitionState("entering");
      previousPathRef.current = location.pathname;

      // Scroll to top during transition
      window.scrollTo({ top: 0, behavior: "instant" });

      const enterTimer = setTimeout(() => {
        setTransitionState("entered");
      }, 400);

      return () => clearTimeout(enterTimer);
    }, 250);

    return () => clearTimeout(exitTimer);
  }, [location.pathname, children]);

  return (
    <div 
      className={`page-transition page-transition--${transitionState}`}
      aria-live="polite"
    >
      {displayChildren}
    </div>
  );
}
